import { useState } from 'react';
import { ITEM_CONDITION_OPTIONS } from './itemConditions.js';

// Add one item to a quote: brand, model, condition and quantity in one go. It replaces
// a browser prompt() that took a single "brand and model" string. Splitting a customer's
// line into items needs each item's own condition from the start (the operator uses the
// condition the customer submitted), and prompt() blocks page automation.
//
// The new line lands unpriced: set its category with the picker, then reprice it.
export default function AddItemDialog({ defaultCondition = '', busy, onCancel, onConfirm }) {
    const [brand, setBrand] = useState('');
    const [model, setModel] = useState('');
    const [condition, setCondition] = useState(defaultCondition || '');
    const [quantity, setQuantity] = useState('1');
    const [error, setError] = useState(null);

    function confirm() {
        const b = brand.trim();
        const m = model.trim();
        if (!b && !m) { setError('Type a brand or a model.'); return; }
        const qty = Number(quantity);
        if (!Number.isInteger(qty) || qty < 1) { setError('Quantity must be a whole number of 1 or more.'); return; }
        onConfirm({ ...(b ? { brand: b } : {}), ...(m ? { model: m } : {}), ...(condition ? { condition } : {}), quantity: qty });
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content qa-pair-modal" role="dialog" aria-modal="true" aria-label="Add item"
                onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Add item</h2>
                    <button className="modal-close" aria-label="Close" onClick={onCancel}>&times;</button>
                </div>
                <div className="modal-body-scroll">
                    <div className="qa-pair-explain">
                        The new line is added <strong>unpriced</strong>. Set its category, then reprice it.
                    </div>
                    <label className="qa-consign-share">
                        <span>Brand</span>
                        <input type="text" autoFocus value={brand} placeholder="e.g. Yamaha" onChange={e => setBrand(e.target.value)} />
                    </label>
                    <label className="qa-consign-share">
                        <span>Model</span>
                        <input type="text" value={model} placeholder="e.g. NS-10M" onChange={e => setModel(e.target.value)} />
                    </label>
                    <label className="qa-consign-share">
                        <span>Condition</span>
                        <select value={condition} onChange={e => setCondition(e.target.value)}>
                            <option value="">None</option>
                            {ITEM_CONDITION_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                        </select>
                    </label>
                    <label className="qa-consign-share">
                        <span>Quantity</span>
                        <input type="number" min="1" step="1" className="qa-pair-qty-input" value={quantity}
                            onChange={e => setQuantity(e.target.value)} />
                    </label>
                    {error && <div className="qa-pair-error">{error}</div>}
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                    <button className="btn btn-primary" onClick={confirm} disabled={busy}>{busy ? '…' : 'Add item'}</button>
                </div>
            </div>
        </div>
    );
}
